import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

import { emptyObject } from 'ui-components/default-props/empty';
import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { AddressPropType } from '../../../../../../../prop-types/address';
import { EditShiptoAddressValidation } from '../address-validation/edit-shipto-address-validation';
import { useEntitiesSalesOrder } from '../../../../../../../hooks/entities/selectors/sales-orders';
import { useSalesOrderIdContext } from '../../../../../../context/sales-order-id-context-provider';

import messages from '../messages';
import style from './edit-shipto-modal.module.less';

const AddressOptionsSection = ({ formState, isValid, isValidatingAddress, validateAddress, isSaving = false }) => {
  const salesOrderId = useSalesOrderIdContext();
  const { store } = useEntitiesSalesOrder(salesOrderId) || emptyObject;
  const storeSettingsURL = store?.storeGuid ? `/settings/stores/${store?.storeGuid}/storesettings` : '/settings/stores';

  return (
    <div aria-labelledby='aot' className={style['address-options-section']} role='group'>
      <FlexColumn>
        <Text textType={TextType.Label} value={messages.addressOptionsSectionTitle} />
        <Text
          className={style['address-options-subtitle']}
          formattedMessageValues={{
            a: (chunks) => <Link to={storeSettingsURL}>{chunks}</Link>,
          }}
          textType={TextType.Paragraph}
          value={messages.addressOptionsStoreSettingSubtitle}
        />
      </FlexColumn>
      <EditShiptoAddressValidation
        formState={formState}
        isSaving={isSaving}
        isValid={isValid}
        isValidatingAddress={isValidatingAddress}
        validateAddress={validateAddress}
      />
    </div>
  );
};

AddressOptionsSection.propTypes = {
  formState: AddressPropType.isRequired,
  isValid: PropTypes.bool.isRequired,
  isValidatingAddress: PropTypes.bool.isRequired,
  validateAddress: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
};

export default AddressOptionsSection;
